module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "my-overlay",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      fullscreen: _vm.fullscreen,
      onMobile: _vm.onMobile
    }
  }, [_c('h4', {
    staticClass: "modal__title"
  }, [(_vm.fullscreen && !_vm.altFullscreenHeader) ? _c('span', {
    staticClass: "dismisser",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back_ios")])], 1) : _vm._e(), _vm._v(" "), (_vm.fullscreen && _vm.altFullscreenHeader) ? _c('div', {
    staticClass: "pa-2 dflex align-center justify-space-between width100"
  }, [_c('div', {
    staticClass: "flex-grow text-center"
  }, [_c('img', {
    attrs: {
      "height": "24",
      "src": require('@/assets/nav_logo_primary.png')
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require('@/assets/closeIcon.svg'),
      "width": "18"
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('span', {
    staticClass: "flex-grow text-center"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal__header"
  }, [_c('v-btn', {
    class: {
      selected: _vm.active_tab == 'Album'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('Album')
      }
    }
  }, [_vm._v("Album")]), _vm._v(" "), _c('v-btn', {
    class: {
      selected: _vm.active_tab == 'ShopProduct'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('ShopProduct')
      }
    }
  }, [_vm._v("Product")]), _vm._v(" "), (_vm.showVideo) ? _c('v-btn', {
    class: {
      selected: _vm.active_tab == 'Video'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('Video')
      }
    }
  }, [_vm._v("\n          Video\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.active_tab == 'Album') ? _c('div', {
    staticClass: "modal__content"
  }, _vm._l((_vm.albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "media",
      class: {
        selected: _vm.attachId == album.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem('Album', album)
        }
      }
    }, [_c('div', {
      staticClass: "media__header"
    }, [_c('div', {
      staticClass: "media__image",
      style: (("background-image: url(" + (album.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "media__content"
    }, [_c('label', {
      staticClass: "media__title"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('label', {
      staticClass: "media__subtitle"
    }, [_vm._v(_vm._s(album.user.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'ShopProduct') ? _c('div', {
    staticClass: "modal__content"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "media",
      class: {
        selected: _vm.attachId == product.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem('ShopProduct', product)
        }
      }
    }, [_c('div', {
      staticClass: "media__header"
    }, [_c('div', {
      staticClass: "media__image",
      style: (("background-image: url(" + (product.covers[0].cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "media__content"
    }, [_c('label', {
      staticClass: "media__title"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('label', {
      staticClass: "media__subtitle"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.showVideo && _vm.active_tab == 'Video') ? _c('div', {
    staticClass: "modal__content"
  }, _vm._l((_vm.videos), function(video, index) {
    return _c('div', {
      key: index,
      staticClass: "media",
      class: {
        selected: _vm.attachId == video.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem('Video', video)
        }
      }
    }, [_c('div', {
      staticClass: "media__header"
    }, [_c('div', {
      staticClass: "media__image _vid",
      style: (("background-image: url(" + (video.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "media__content"
    }, [_c('label', {
      staticClass: "media__title"
    }, [_vm._v(_vm._s(video.name))]), _vm._v(" "), _c('label', {
      staticClass: "media__subtitle"
    }, [_vm._v(_vm._s(video.user.username))])])])
  })) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35306e0e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/components/attach_picker.vue
// module id = 1677
// module chunks = 180